var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { PureComponent, createElement } from 'react';
import PropTypes from 'prop-types';
import { ComponentsManager } from '@comall-backend-builder/core';
import { extendsParentProps } from '../component-props';

var Anchor = function (_super) {
  __extends(Anchor, _super);

  function Anchor(props) {
    var _this = _super.call(this, props) || this;

    _this.renderContent = _this.renderContent.bind(_this);
    return _this;
  }

  Anchor.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        style = _a.style,
        className = _a.className,
        content = _a.content;
    var props = {
      id: id,
      style: style,
      className: className
    };
    return React.createElement("div", __assign({}, props), content ? this.renderContent() : null);
  };

  Anchor.prototype.renderContent = function () {
    var _a = this.props.content,
        componentName = _a.component,
        children = _a.children,
        otherProps = __rest(_a, ["component", "children"]);

    var component = ComponentsManager.get(componentName);
    var props = extendsParentProps(otherProps, this.props);
    return createElement(component, props, children);
  };

  Anchor.propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    id: PropTypes.string,
    content: PropTypes.object
  };
  return Anchor;
}(PureComponent);

export { Anchor };